// extracted by mini-css-extract-plugin
export default {"root":"Statics_root__UiC06","statics":"Statics_statics__mOQ7m"};